import { render, staticRenderFns } from "./TheHeaderChooseLocation.vue?vue&type=template&id=70e27626"
import script from "./TheHeaderChooseLocation.vue?vue&type=script&lang=js"
export * from "./TheHeaderChooseLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports